import * as React from "react";
import { useGetSkillsQuery } from "../../services/skill.service";
import { Skill } from "../../types/skill";
import SelectBase, { SelectOption } from "../../components/global/SelectBase";

const SelectSkills = ({
  onChange,
  values,
}: {
  onChange: (ids?: number[]) => void;
  values: number[];
}) => {
  const {
    data: skills,
    isLoading,
    isFetching,
  } = useGetSkillsQuery({
    page: 0,
    pageSize: 1000,
    sortField: "name",
    sortMode: "asc",
  });

  const options = React.useMemo<SelectOption[]>(() => {
    return (skills?.data || []).map((skill) => ({
      label: skill.name,
      value: skill.id,
    }));
  }, [skills]);

  const selectedValues = React.useMemo<SelectOption[]>(() => {
    return options?.filter((it) => values?.includes(it.value as number)) || [];
  }, [options, values]);

  return (
    <SelectBase
      options={options}
      value={selectedValues}
      onChange={(newValue) => {
        const options = newValue as SelectOption[] | null;
        onChange(options?.map((it) => it.value as number));
      }}
      label="Skills"
      placeholder="Search..."
      isMulti={true}
      isSearchable={true}
      isLoading={isLoading || isFetching}
    />
  );
};
export default SelectSkills;
